import { UserRound } from 'lucide-react';

import { cn } from '../../lib/cn';

// Figma semantic dots: positive #69d86b, negative #ed3f3f, 1px dark ring so it reads on any avatar.
export const PresenceDot = ({ active, className, style }) => (
  <span
    aria-hidden
    style={style}
    className={cn(
      'block rounded-full border border-dq-bg',
      active ? 'bg-[#69d86b]' : 'bg-[#ed3f3f]',
      className
    )}
  />
);

// Initials from a real name, else one neutral glyph; shared by the rail, search and header.
export const AvatarInitials = ({ initials, size }) =>
  initials || (
    <UserRound
      aria-hidden
      style={{ width: Math.round(size * 0.45), height: Math.round(size * 0.45) }}
    />
  );

// Customer identity: initials in the Figma dark circle with the presence dot bottom-right.
export const CustomerAvatar = ({ initials, active, size = 40, className }) => {
  const dot = Math.round(size * 0.2);
  return (
    <span
      className={cn('relative block shrink-0', className)}
      style={{ width: size, height: size }}
    >
      <span
        className="flex h-full w-full items-center justify-center rounded-full bg-dq-900 font-dq font-bold text-dq-400"
        style={{ fontSize: Math.round(size * 0.35) }}
      >
        <AvatarInitials initials={initials} size={size} />
      </span>
      <PresenceDot
        active={active}
        className="absolute"
        style={{ width: dot, height: dot, left: size - dot - 2, top: size - dot - 2 }}
      />
    </span>
  );
};
